import React, { useEffect, useState } from "react";
import "./FestivalTypes.scss";
import { useDispatch } from "react-redux";

import FestivalSelectionTemplate from "./FestivalSelectionTemplate";
import { useNavigate, useSearchParams } from "react-router-dom";
import ProtectedComponent from "../../../../../components/ProtectedComponent";
import NavigationLayout from "../../../navigation";
import { clientRoutes } from "../../../../../utils/routes";
import BackArrowIcon from "../../../../../components/icons/BackArrowIcon";
import LockIcon2 from "../../../../../components/icons/LockIcon2";
import RoundTrueIcon from "../../../../../components/icons/RoundTrueIcon";
import SearchIcon from "../../../../../components/icons/SearchIcon";
import { TemplatesApi } from "../../../../../utils/api/Templates";
import Loading from "../../../../loading/Loading";

const FestivalTypes = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [searchParams] = useSearchParams();

  const type: any = searchParams?.get("type");
  const subscription_type: any = searchParams?.get("subscription_type");
  const listing_type: any = searchParams?.get("listing_type");

  const [festivalTypes, setFestivalTypes] = useState([]);
  const [loading, setLoading] = useState(true);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedFestival, setSelectedFestival] = useState(null);
  const [configuredTypes, setConfiguredTypes] = useState<string[]>([]);
  const [isLoadingConfigs, setIsLoadingConfigs] = useState(true);
  const [refreshConfigs, setRefreshConfigs] = useState(false);

  const fetchConfiguredTemplates = async () => {
    setIsLoadingConfigs(true);
    try {
      const promises = festivalTypes.map(async (item: any) => {
        const response = await TemplatesApi.getAgencyfestivalTemplates({
          festival_type: item.slug,
        });

        if (response.success && response.data?.data) {
          const hasAnyConfig = Object.values(response.data.data).some(
            (postType: any) =>
              postType?.templates?.some((template: any) =>
                template?.config?.some((c: any) => c.status === "active")
              )
          );

          return hasAnyConfig ? item.slug : null;
        }

        return null;
      });

      const results = await Promise.all(promises);
      setConfiguredTypes(
        results.filter((slug): slug is string => slug !== null)
      );
    } finally {
      setIsLoadingConfigs(false);
    }
  };

  useEffect(() => {
    const fetchFestivals = async () => {
      try {
        const res = await TemplatesApi.getFestivalTypes({
          search: "",
          page: 1,
          limit: 200,
          created_at: "desc",
        });

        if (res?.data?.success) {
          setFestivalTypes(res.data.data.docs || []);
        }
      } catch (error) {
        console.error("Failed to load festival types:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFestivals();
  }, []);

  useEffect(() => {
    if (festivalTypes.length > 0) {
      fetchConfiguredTemplates();
    }
  }, [festivalTypes]);

  const filteredFestivals = festivalTypes.filter((item: any) =>
    (item.label || item.name || "")
      .toLowerCase()
      .includes(searchQuery.toLowerCase())
  );

  const handleSelectFestival = (festivalItem: any) => {
    setSelectedFestival(festivalItem);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedFestival(null);

    setRefreshConfigs((prev) => !prev);
  };

  const isConfiguredForSubtype = (slug: string) => false;

  useEffect(() => {
    if (festivalTypes.length > 0) {
      fetchConfiguredTemplates();
    }
  }, [festivalTypes, refreshConfigs]);

  return (
    <ProtectedComponent>
      <NavigationLayout>
        <div className="announcement-property-stage-container">
          <div
            className="propertie-view-back-btn"
            onClick={() => navigate(clientRoutes.designTemplates)}
          >
            <div className="back-icon">
              <BackArrowIcon />
            </div>
            <p className="bakc-text-contain">Back to Template Configuration</p>
          </div>

          <div className="design-templates-heading">
            <p>Configure Festival Post Templates</p>
          </div>

          <div className="property-stage-sub-head">
            <p>Select festival to continue design templates selection</p>
          </div>

          <div className="festival-search-wrapper">
            <div className="festival-search-box">
              <SearchIcon />
              <input
                type="text"
                placeholder="Search Festival"
                className="festival-search-input"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
          </div>

          <div className="property-stage-two property-stage-contain">
            {filteredFestivals.map((item: any) => {
              const isConfigured = configuredTypes.includes(item.slug);

              return (
                <div key={item.slug}>
                  <button
                    className="property-stage-box"
                    onClick={() => handleSelectFestival(item)}
                  >
                    <div className="proprty-title">
                      <div className="proprty-title-and-lock-icon">
                        <div className="lock-icon">
                          <LockIcon2 />
                        </div>

                        <p className="proprty-title-text">
                          {item.label || item.name}
                        </p>
                      </div>
                    </div>

                    <div className="pending-message">
                      {isLoadingConfigs ? (
                        <p className="loading-text">
                          <Loading />
                        </p>
                      ) : isConfigured ? (
                        <>
                          <RoundTrueIcon />
                          <p>Configured</p>
                        </>
                      ) : (
                        <>
                          <img
                            src="/images/HistoryTemplate.svg"
                            alt="Pending Icon"
                            className="pending-icon"
                          />
                          <p>
                            Template Selection Is <br /> Pending
                          </p>
                          <p className="select-template">Select Template</p>
                        </>
                      )}
                    </div>
                  </button>
                </div>
              );
            })}
          </div>
        </div>

        {selectedFestival && (
          <FestivalSelectionTemplate
            isOpen={isModalOpen}
            onClose={handleCloseModal}
            festivalTypes={selectedFestival}
          />
        )}
      </NavigationLayout>
    </ProtectedComponent>
  );
};

export default FestivalTypes;
